/**
 * "253h 47m" — hours + minutes, matching the salary breakdown shown on the
 * staff/account payroll pages. Whole hours drop the minutes ("21h").
 */
export function formatHoursMinutes(minutes: number | null | undefined): string {
  if (!minutes || minutes <= 0) return '0h 0m';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
}

/**
 * Same as formatHoursMinutes but renders a dash for an empty duration — the convention
 * used across the attendance screens. Shared by the attendance report list and the punch
 * timeline modal so a value cannot be formatted two different ways on two screens.
 */
export function formatAttendanceHours(minutes: number | null | undefined): string {
  if (!minutes || minutes <= 0) return '–';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
}
